import React, { useState } from 'react';

// "Log in as" — the strip every page shows while an admin is inside somebody else's account
// (src/auth/impersonation.js). It must be impossible to forget whose account this is: it is not
// dismissible, and Exit is always one press away. `/api/auth/me` sets user.impersonatedBy.
//
// `floating` pins it to the top of the viewport for pages without the shared header (the chart viewer).
export default function ViewingAsBanner({ user, floating = false }) {
  const [state, setState] = useState({ busy: false, error: null });
  if (!user || !user.impersonatedBy) return null;

  const exit = async () => {
    setState({ busy: true, error: null });
    try {
      const r = await fetch('/api/auth/login-as/exit', { method: 'POST', credentials: 'include' });
      const d = await r.json().catch(() => ({}));
      // A 401 means the admin session itself is gone (password changed, demoted): sign in again.
      if (r.status === 401) { window.location.assign('/login?return=%2Fadmin'); return; }
      if (!r.ok) throw new Error(d.error || 'Could not exit');
      window.location.assign('/admin');
    } catch (e) {
      setState({ busy: false, error: e.message || 'Could not exit' });
    }
  };

  return (
    <div role="status" aria-live="polite" style={{
      display: 'flex', alignItems: 'center', gap: 12, padding: '10px 24px', fontSize: 14, flexWrap: 'wrap',
      background: 'color-mix(in oklab, var(--amber, #d29922) 22%, var(--surface))',
      borderBottom: '2px solid var(--amber, #d29922)', color: 'var(--text)',
      ...(floating ? { position: 'fixed', top: 0, left: 0, right: 0, zIndex: 10000 } : {}),
    }}>
      <span>
        You are logged in as <b>{user.email}</b>. Settings can be fixed; orders, broker connections, payments
        and account changes are off.
        <span style={{ color: 'var(--muted)' }}> (Admin: {user.impersonatedBy.email})</span>
      </span>
      {state.error && <span role="alert" style={{ color: 'var(--loss)', fontWeight: 650 }}>{state.error}</span>}
      <button type="button" onClick={exit} disabled={state.busy} style={{
        marginLeft: 'auto', padding: '6px 14px', borderRadius: 8, border: '1px solid var(--text)', background: 'var(--surface)',
        color: 'var(--text)', fontSize: 13.5, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit',
      }}>{state.busy ? 'Exiting…' : 'Exit and return to admin'}</button>
    </div>
  );
}
